import React from 'react';
import { Card, Typography, Descriptions, Space } from 'antd';
import { InfoCircleOutlined, AppstoreOutlined, UserOutlined, CrownOutlined, TagOutlined, CalendarOutlined, MailOutlined } from '@ant-design/icons';
import { getUserRole } from '../utils/tokenUtils';
import { VERSION_INFO } from '../utils/versionInfo';

const { Title, Text, Link } = Typography;

const About = () => {
  const userRole = getUserRole();

  const isDev = import.meta.env.MODE === 'dev' || window.location.hostname.includes('localhost');
  const isUat = import.meta.env.MODE === 'uat' || window.location.hostname.includes('uat')|| window.location.hostname.includes('localhost');
  const isStaging = import.meta.env.MODE === 'staging' || window.location.hostname.includes('staging');
  const appNameExt = isDev ? ' Dev' : isUat ? ' UAT' : isStaging ? ' Staging' : '';
  
  return (
    <div className="about-container" style={{ padding: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%' }}>
          <Card 
            className="about-card" 
            bordered={true}
            style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>              
              <Title level={3} style={{ margin: '8px 0', paddingBottom: '16px' }}>
                About This App
              </Title>
            </div>

            <Descriptions bordered>
              <Descriptions.Item label={<span><AppstoreOutlined /> App Name</span>}>
                {VERSION_INFO.appName}{appNameExt}
              </Descriptions.Item>
              
              <Descriptions.Item label={<span><UserOutlined /> User Role</span>}>
                {userRole}
              </Descriptions.Item>
              
              <Descriptions.Item label={<span><CrownOutlined /> Plan Level</span>}>
                {VERSION_INFO.planLevel}
              </Descriptions.Item>
              
              <Descriptions.Item label={<span><TagOutlined /> Build Version</span>}>
                {VERSION_INFO.version} (Commit #{VERSION_INFO.commitHash})
              </Descriptions.Item>
              
              <Descriptions.Item label={<span><CalendarOutlined /> Build Date</span>}>
                {VERSION_INFO.buildDate}
              </Descriptions.Item>
            </Descriptions>
            
            <Space direction="vertical" size="middle" style={{ width: '100%', marginTop: '24px' }}>
              <div>
                <Text strong>Terms & Conditions:</Text>{' '}
                <Link href="https://www.rightnowresponse.com/terms-conditions" target="_blank">
                  View Terms
                </Link>
              </div>
              
              <div>
                <Text strong>Privacy Policy:</Text>{' '}
                <Link href="https://www.rightnowresponse.com/privacy-policy" target="_blank">
                  View Policy
                </Link>
              </div>
              
              <div style={{ marginTop: '16px' }}>
                <Title level={5}>Need Help?</Title>
                <div>
                  Email us at
                  <Link href="mailto:support@rnresponse.co.za">
                    <MailOutlined style={{ margin: '0 4px' }} />
                    support@rnresponse.co.za
                  </Link>
                </div>
              </div>
            </Space>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;
